module.exports = __webpack_public_path__ + "assets/img/e9e2-se.svg";